import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./i18n";

import "./index.scss";
import "./styles/base.scss";
import { Amplify } from "aws-amplify";

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.
import { configureAmp } from "src/auth/config";
import { RouteMap } from "src/routing/routes";
import { getActiveFestivalEasterEgg } from "src/config/festival-easter-eggs";

import { applyThemeMode } from "src/hooks/useThemeMode";
import { useSettingsStore } from "src/stores/useSettingsStore";

Amplify.configure(configureAmp);

// Apply the saved theme before the first render so dark-mode users don't see
// a light flash. Settings persist to localStorage, which hydrates synchronously.
applyThemeMode(useSettingsStore.getState().themeMode);

// Easter eggs: swap the favicon at runtime on specific dates. The
// build-time favicon (bart_logo_squared.png, set in webpack.config.js) can't
// react to the visit date, so we override it here for visitors on the day.
const easterEggFavicon = getActiveFestivalEasterEgg()?.image;

if (easterEggFavicon) {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = easterEggFavicon;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteMap />
    </BrowserRouter>
  </React.StrictMode>,
);
